import {getConfig} from '../../services/config/configService';

const getApp = () => getConfig().app;

const getMarket = () => getApp().market;
const getUserGroup = () => getApp().userGroup;
const getConsoleLogConfig = () => getApp().consoleLog;
const getCloudWatchLogConfig = () => getApp().cloudWatchLog;
const getDeviceConfigHost = () => getApp().deviceConfigHost;
const getAwsAmplifyConfig = () => getApp().awsAmplifyConfig;

const configAppGetters = {
    getMarket,
    getUserGroup,
    getAwsAmplifyConfig,
    getConsoleLogConfig,
    getCloudWatchLogConfig,
    getDeviceConfigHost,
};

export default configAppGetters;
